import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';
import type { RootState } from '@root/store/store';

export type Amount = {
  currencySymbol: string;
  amount: number;
  userCurrency: string;
};

export const BALANCE_SLICE_KEY = 'balance';

export interface BalanceSliceState {
  balance: Amount;
  exposure: Amount;
}

const initialState: BalanceSliceState = {
  balance: {
    currencySymbol: '',
    amount: 0,
    userCurrency: '',
  },
  exposure: {
    currencySymbol: '',
    amount: 0,
    userCurrency: '',
  },
};

const balanceSlice = createSlice({
  name: BALANCE_SLICE_KEY,
  initialState,
  reducers: {
    setBalance: (state, action: PayloadAction<Amount>) => {
      state.balance = action.payload;
    },
    setExposure: (state, action: PayloadAction<Amount>) => {
      state.exposure = action.payload;
    },
  },
});

const balanceReducer = balanceSlice.reducer as Reducer;
export default balanceReducer;

export const balanceSelector = (state: RootState): BalanceSliceState =>
  state.balance;

export const balanceActions = balanceSlice.actions;
